import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class ProductDataChunkEntity extends MongoEntity {
  static override _class = 'ProductDataChunkEntity';
  static override _collectionName = 'ProductDataChunkEntity';

  @Field(() => String) article_nr: Maybe<string>;
  @Field(() => String) category: Maybe<string>;
  @Field(() => String) color: Maybe<string>;
  @Field(() => String) knowledge_type: Maybe<string>;
  @Field(() => String) material: Maybe<string>;
  @Field(() => String) name: Maybe<string>;
  @Field(() => String) product_type: Maybe<string>;
  @Field(() => String) value: Maybe<string>;
  @Field(() => Date) createdAt: Maybe<Date>;

  static override async beforeCreate(entity: ProductDataChunkEntity) {
    await super.beforeCreate(entity);
    entity.createdAt = new Date();
  }
}